module.exports = __webpack_public_path__ + "assets/img/17.976dc6da.png";